import { useGraphQLQuery } from '@opengov/bnp-core';
import isEmpty from 'lodash/isEmpty';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { graphql } from '../../../../../../gql-generated/hasura';
import { useToast } from '../../../../Toast/context/useToast.context';
import locale from '../../customReports-locale.json';
import { customReportsQueryKeys } from '../../hooks/customReportsQueryKeys';

const FetchSpreadsheetNamedRangesForEditReportModalQuery = graphql(`
  query GetSpreadsheetNamedRangesForEditReportModal($spreadsheetId: uuid!) {
    spreadsheetNamedRanges(where: { spreadsheetId: { _eq: $spreadsheetId } }) {
      ...EditReportModal_NamedRangesFragment
    }
  }
`);

export function useFetchNamedRanges({ spreadsheetId }: { spreadsheetId: string }) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: customReportsQueryKeys.namedRangesForEditReportModal(spreadsheetId),
    variables: { spreadsheetId: spreadsheetId },
    document: FetchSpreadsheetNamedRangesForEditReportModalQuery,
    url: HASURA_SERVICE_URL,
    options: {
      enabled: !isEmpty(spreadsheetId),
      select: (data) => data.spreadsheetNamedRanges,
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchCustomReports,
          severity: 'error'
        });
      }
    }
  });
}
